import { SVGProps, Ref, forwardRef } from 'react';

export const PlusBoldFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.682.5c1.285 0 1.928 0 2.328.4.4.399.4 1.042.4 2.328V4.59h1.363c1.285 0 1.928 0 2.328.4.399.399.399 1.042.399 2.327v1.364c0 1.285 0 1.928-.4 2.328-.399.4-1.042.4-2.327.4h-1.364v1.363c0 1.285 0 1.928-.4 2.328-.399.399-1.042.399-2.327.399H7.318c-1.285 0-1.928 0-2.328-.4-.4-.399-.4-1.042-.4-2.327v-1.364H3.229c-1.286 0-1.93 0-2.329-.4C.5 10.61.5 9.968.5 8.683V7.318C.5 6.033.5 5.39.9 4.99c.399-.4 1.042-.4 2.328-.4H4.59V3.229c0-1.286 0-1.93.4-2.329C5.39.5 6.032.5 7.317.5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlusBoldFilledSize16Glyph.displayName = 'PlusBoldFilledSize16Glyph';
